import { render } from "./MyActivePublications.vue.js?vue&type=template&id=e86b47fc!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyActivePublications.vue?vue&type=template&id=e86b47fc"
import script from "./MyActivePublications.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyActivePublications.vue?vue&type=script&lang=js"
export * from "./MyActivePublications.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyActivePublications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/MyActivePublications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e86b47fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e86b47fc', __exports__)) {
    api.reload('e86b47fc', __exports__)
  }
  
  module.hot.accept("./MyActivePublications.vue.js?vue&type=template&id=e86b47fc!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyActivePublications.vue?vue&type=template&id=e86b47fc", () => {
    api.rerender('e86b47fc', render)
  })

}


export default __exports__